const HEX_REGEX = /^[a-fA-F0-9]{6}$/;
export function processThemeValues(themeObject: Object) {
  const result: { [key: string]: string } = {};
  for (const [key, value] of Object.entries(themeObject)) {
    if (value === null) {
      continue;
    }

    if (key.includes('Color')) {
      let colorValue = value;
      if (value[0] === '#') {
        colorValue = value.slice(1);
      }

      if (HEX_REGEX.test(colorValue)) {
        result[key] = `#${colorValue}`;
      } else {
        continue;
      }
    } else {
      result[key] = value.toString();
    }
  }

  return result;
}
